import axios from 'axios';
import { API_URL } from '../config';
export const getProductionHandovers = async (filters = {}) => {
  const params = {
    page: filters.page || 1,
    limit: filters.limit || 25,
  };

  if (filters.status) {
    params.status = filters.status;
  }

  if (filters.productionOrder?.trim()) {
    params.productionOrder = filters.productionOrder.trim();
  }

  if (filters.batch?.trim()) {
    params.batch = filters.batch.trim();
  }

  if (
    filters.materialNumber !== '' &&
    filters.materialNumber !== null &&
    filters.materialNumber !== undefined
  ) {
    params.materialNumber = filters.materialNumber;
  }

  if (filters.dateFrom) {
    params.dateFrom = new Date(`${filters.dateFrom}T00:00:00`).toISOString();
  }

  if (filters.dateTo) {
    params.dateTo = new Date(`${filters.dateTo}T23:59:59.999`).toISOString();
  }

  const response = await axios.get(`${API_URL}/production-handover`, {
    params,
    withCredentials: true,
  });

  return response.data;
};

export const getProductionHandover = async (id) => {
  const response = await axios.get(`${API_URL}/production-handover/${id}`, {
    withCredentials: true,
  });

  return response.data;
};

export const requestProductionHandover = async (id) => {
  const response = await axios.patch(
    `${API_URL}/production-handover/${id}/request`,
    {},
    {
      withCredentials: true,
    },
  );

  return response.data;
};

export const retryProductionHandover = async (id) => {
  const response = await axios.patch(
    `${API_URL}/production-handover/${id}/retry`,
    {},
    {
      withCredentials: true,
    },
  );

  return response.data;
};

export const finalizeProductionHandover = async (id) => {
  const response = await axios.patch(
    `${API_URL}/production-handover/${id}/finalize`,
    {},
    {
      withCredentials: true,
    },
  );

  return response.data;
};

export const reviewProductionHandover = async (id, decision, comment) => {
  const response = await axios.patch(
    `${API_URL}/production-handover/${id}/review`,
    {
      decision,
      comment,
    },
    {
      withCredentials: true,
    },
  );

  return response.data;
};
